module.exports = __webpack_public_path__ + "static/media/日历6@2x.991d50fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历6@2x.png
// module id = 1379
// module chunks = 0